
import { Component, Vue } from "vue-property-decorator";
import {
  prescriptionProductUnitList,
  savePrescriptionProductUnit,
  switchPrescriptionProductUnit,
  clearEnabledProductUnitCache,
} from "@/api/prescriptionDb";

@Component({ name: 'prescription-db-productUnitConfig' })
export default class ProductUnitConfig extends Vue {
  tableData: any[] = [];
  loading = false;

  dialogVisible = false;
  saveLoading = false;
  unitName = "";

  mounted() {
    this.getList();
  }

  // 全量列表，含已关闭
  getList() {
    this.loading = true;
    prescriptionProductUnitList().then((res: any) => {
      this.tableData = res.data || [];
    }).finally(() => {
      this.loading = false;
    });
  }

  handleAdd() {
    this.unitName = "";
    this.dialogVisible = true;
  }

  handleSave() {
    const unitName = (this.unitName || "").trim();
    if (!unitName) {
      this.$message.warning("处方库单位不能为空");
      return;
    }
    if (unitName.length > 4) {
      this.$message.warning("处方库单位最多4个字");
      return;
    }
    this.saveLoading = true;
    savePrescriptionProductUnit({ unitName }).then(() => {
      this.$message.success("保存成功");
      this.dialogVisible = false;
      clearEnabledProductUnitCache();
      this.getList();
    }).finally(() => {
      this.saveLoading = false;
    });
  }

  // 开关变更：失败时回滚本地状态
  handleSwitch(row: any, enabled: number) {
    this.$set(row, "switchLoading", true);
    switchPrescriptionProductUnit({ id: row.id, enabled }).then(() => {
      clearEnabledProductUnitCache();
      this.$message.success("操作成功");
      this.getList();
    }).catch(() => {
      row.enabled = enabled === 1 ? 0 : 1;
    }).finally(() => {
      this.$set(row, "switchLoading", false);
    });
  }

  headerCellStyle() {
    return { background: "#F8F9FA", color: "#1A1A1C", textAlign: "center" };
  }

  cellStyle() {
    return { textAlign: "center" };
  }
}
